import React from 'react';

/*Hooks*/
import { useSelector, useDispatch } from 'react-redux';

/*Components*/
import { IconButton, Box, AppBar, useMediaQuery, Toolbar, styled, Stack } from '@mui/material';
import Notifications from './Notifications';
import Profile from './Profile';
import Language from './Language';

/*StoreS*/
import { toggleSidebar, toggleMobileSidebar } from '@store/customizer/CustomizerSlice';
import { IconHelp, IconMenu2 } from '@tabler/icons-react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

const roles = localStorage.getItem('roles');
const isImpersonation = localStorage.getItem('isImpersonation');

const Header = ({ Impersonation, TestingMode }) => {
  const { t } = useTranslation();

  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const customizer = useSelector((state) => state.customizer);

  const dispatch = useDispatch();

  return (
    <AppBarStyled customizer={customizer} position="sticky" color="default">
      <ToolbarStyled>
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={lgUp ? () => dispatch(toggleSidebar()) : () => dispatch(toggleMobileSidebar())}
        >
          <IconMenu2 size="20" />
        </IconButton>
        <Impersonation />
        <TestingMode />
        <Box flexGrow={1} />
        <Stack spacing={1} direction="row" alignItems="center">
          <Language />
          {(isImpersonation || roles === 'BTC') && <Notifications />}
          {/* {lgDown ? <MobileRightSidebar /> : null} */}
          <Tooltip
            placement="bottom"
            color="#fff"
            overlayInnerStyle={{ color: '#2A3547' }}
            title={t("CORE:user's_manual")}
          >
            <a
              href="https://wiki.sukienthongminh.com/"
              target="_blank"
              style={{
                cursor: 'pointer',
                display: 'flex',
                color: '#2A3546',
              }}
            >
              <IconButton size="medium" color="inherit">
                <IconHelp stroke={1.5} />
              </IconButton>
            </a>
          </Tooltip>

          <Profile />
        </Stack>
      </ToolbarStyled>
    </AppBarStyled>
  );
};

const AppBarStyled = styled(AppBar)(({ theme, customizer }) => ({
  boxShadow: 'none',
  borderBottom: '1px solid #E5EAEF',
  background: theme.palette.background.paper,
  justifyContent: 'center',
  backdropFilter: 'blur(4px)',
  [theme.breakpoints.up('lg')]: {
    minHeight: customizer.TopbarHeight,
  },
}));
const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
  width: '100%',
  color: theme.palette.text.secondary,
}));

export default Header;
